import styled from 'styled-components';
import { remCalc, colors, media, layout } from '@prisjakt/ui-base';
import { VARIANTS } from '@prisjakt/ui-store-logo';
import ThumbUpIcon from 'mdi-react/ThumbUpIcon';
import HomeDeliveryComponent from '../home-delivery';

export { VARIANTS };

export const StoreInfo = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  margin: 0;
  padding: 0;

  ${media.smallOnly`
      padding: 0;
    `};
`;

export const StoreLogoAndRating = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: flex-start;
  text-align: left;

  > * {
    margin-left: 0.5rem;
    &:first-child {
      margin-left: 0;
    }
  }

  ${media.largeUp`
    align-items: center;
  `}

  ${media.mediumDown`
    flex-direction: column;

    > * {
      margin-left: 0;
    }
  `};
`;

export const RatingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RatingWrapper = styled.div`
  margin-top: 2px;
`;

export const RecommendedRetailer = styled.div`
  font-size: ${remCalc(12)};
  white-space: nowrap;
  align-self: normal;
  margin-top: 0.3rem;
  color: ${props => props.theme.text.secondary};

  ${media.smallOnly`
    display: none;
  `};
`;

export const RecommendedRetailerIcon = styled(ThumbUpIcon).attrs({ size: 12 })`
  fill: ${colors.darkGray2};
  margin-right: 0.3rem;
`;

export const StoreInfoTitle = styled.span`
  /* Visually hidden since this text is primarily for Google */
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const CountryFlagWrapper = styled.div`
  display: flex;

  img {
    max-height: 11px;
  }
`;

export const HomeDelivery = styled(HomeDeliveryComponent)`
  padding-right: ${layout.spacing.xSmall};
`;
